import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IPasteToolButtonProps extends IconButtonProps {
    tooltip?: string;
}

export const PasteToolButton = (props: IPasteToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Paste}
        icon={<ContentPasteIcon />}
    />
);
